<template>
  <div class="service detail wrap">
    <div class="text-bg sso">
      <div class="text-wrap">
        <p>{{ $t('solution.detail.sso.lineText.01') }}</p>
        <p>{{ $t('solution.detail.sso.lineText.02') }}</p>
        <p>{{ $t('solution.detail.sso.lineText.03') }}</p>
      </div>
    </div>
    <HalfPageLayout class="sso title">
      <template #half-left>
        <div class="img sso"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <SsoTabs current="sso" />
            <h3 style="line-height: 1.1">
              {{ $t('solution.title.sso') }}
            </h3>
            <h6>Nets* Single Sign On</h6>
            <h4>{{ $t('solution.detail.sso.subTitle') }}</h4>
          </div>
          <h5>{{ $t('solution.detail.sso.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="sso summary">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.sso.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:lock-open-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.sso.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.sso.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:apple-podcasts-logo-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.sso.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.sso.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:circles-three-plus-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.sso.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.sso.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="sso summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.sso.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:cloud-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.sso.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.sso.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:gear-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.sso.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.sso.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:arrow-square-in-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.sso.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.sso.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>
    <section class="section sso benefit">
      <h2 class="hl section-title">{{ $t('solution.detail.sso.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="inner-contents">
          <div class="contents-list">
            <dl data-aos="zoom-in">
              <div class="img sso"></div>
              <dt>{{ $t('solution.detail.sso.benefit.contents.01.title') }}</dt>
              <dd>{{ $t('solution.detail.sso.benefit.contents.01.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img sso"></div>
              <dt>{{ $t('solution.detail.sso.benefit.contents.02.title') }}</dt>
              <dd>{{ $t('solution.detail.sso.benefit.contents.02.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img sso"></div>
              <dt>{{ $t('solution.detail.sso.benefit.contents.03.title') }}</dt>
              <dd>{{ $t('solution.detail.sso.benefit.contents.03.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img sso"></div>
              <dt>{{ $t('solution.detail.sso.benefit.contents.04.title') }}</dt>
              <dd>{{ $t('solution.detail.sso.benefit.contents.04.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img sso"></div>
              <dt>{{ $t('solution.detail.sso.benefit.contents.05.title') }}</dt>
              <dd>{{ $t('solution.detail.sso.benefit.contents.05.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img sso"></div>
              <dt>{{ $t('solution.detail.sso.benefit.contents.06.title') }}</dt>
              <dd>{{ $t('solution.detail.sso.benefit.contents.06.desc') }}</dd>
            </dl>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'
import SsoTabs from '@/components/SsoTabs'

export default {
  name: 'SolutionDetailSSO',
  components: { SvgGear, HalfPageLayout, Icon, SsoTabs }
}
</script>

<style scoped>
</style>
